import LegalDocument from '../components/LegalDocument';
import { termsOfServiceLines } from '../data/legalDocuments';

const TermsOfService = () => <LegalDocument lines={termsOfServiceLines} />;

export default TermsOfService;
